module.exports = __webpack_public_path__ + "img/21.3b0705cf.jpg";